import React, { useState, useEffect } from 'react';
import * as Utils from '../../common/utils';
import * as REQUEST from "../../common/request";
import { Input, message, Modal } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import './index.less';

const PageModel = props => {
    const [url, setUrl] = useState('');
    const [imageFileList, setImageFileList] = useState([]);
    const [content, setContent] = useState('');
    const [name, setName] = useState('');
    const [tel, setTel] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    
    const getbanner = async () => {
        const result = await REQUEST.get({
            url: '/zhujiajiao/v2/file/get',
            data: { id: 5 }
        });
        if (!result) return;
        setUrl(result.data.link);
    };

    useEffect(() => {
        getbanner();
        Utils.setPageTitle('投诉建议');
        return () => false;
    }, [123]);

    const uploadButton = (
        <button style={{ border: 0, background: 'none' }} type="button">
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>照片上传</div>
        </button>
    );

    const getContent = (e) => {
        console.log(e.target.value);
        setContent(e.target.value);
    }
    const onName = (e) => {
        console.log(e.target.value);
        setName(e.target.value);
    }
    const onTel = (e) => {
        console.log(e.target.value);
        setTel(e.target.value);
    }
    const showModal = () => {
        setIsModalOpen(true);
    };

    return (
        <section className="h5comp-container" style={{ minHeight: window.innerHeight }}>
            <div className='h5comp-top-img'>
                <img src={'https://static-yeekin.oss-cn-shanghai.aliyuncs.com/' + url} alt="" />
            </div>
           
            <div className='h5comp-input-text' >
                <Input.TextArea value={content} placeholder='请输入您的投诉建议' onChange={getContent}/>
            </div>

            <div className='h5comp-input-name' onChange={onName} >
                <Input value={name} placeholder='联系人' />
            </div>

            <div className='h5comp-input-name' onChange={onTel}>
                <Input value={tel} placeholder='电话' type='number' max={11}/>
            </div>
            <div className='h5comp-input-submit' onClick={async () => {
                if (!content) {
                    message.error('请输入您的投诉建议');
                    return; 
                }
                if (!name) {
                    message.error('请输入联系人');
                    return;
                }
                //数据提交
                await REQUEST.post({
                    url: '/zhujiajiao/v2/comp/add',
                    data: {
                        content: content,
                        name: name,
                        tel: tel,
                        //数组转字符串
                        file: imageFileList.join(','),
                        status: 0
                    }
                }).then(res => {
                    console.log(res);
                    if(res.ok == 0){
                        setIsModalOpen(true)
                        setContent('');
                        setName('');
                        setTel('');
                        showModal();
                    }
                })
               
            }
            }>提交建议</div>

            <div className='h5comp-input-tel'>
                <div className='h5comp-input-tel-title' onClick={()=>{
                    setTimeout(function () {
                        window.open(`${'tel:02159240077'}`);
                    }, 100);
                }}>咨询电话：021-59240077 <img src={require('./images/bodadianhua.png')}></img></div>
                <div className='h5comp-input-tel-title' onClick={() => {
                    setTimeout(function () {
                        window.open(`${'tel:02159245559'}`);
                    }, 100);
                }}>投诉电话：021-59245559 <img src={require('./images/bodadianhua.png')}></img></div>
                <div className='h5comp-input-tel-title' onClick={() => {
                    setTimeout(function () {
                        window.open(`${'tel:02159242774'}`);
                    }, 100);
                }}>救援电话：021-59242774 <img src={require('./images/bodadianhua.png')}></img></div>
            </div>

            {isModalOpen && (
                <div className="h5comp-overlay">
                    <div className="h5comp-overlay-content">
                        <p>您反馈的问题已收到</p>
                        <p>我们将第一时间把问题转至相关部门</p>
                        <p>核实后会尽快处理</p>
                        <div onClick={() => setIsModalOpen(false)}>关闭</div>
                    </div>
                </div>
            )}

           
        </section>
    );
};

export default PageModel;
